<div *ngFor="let train of trains;trackBy: indexTrackBy">
	<trenitalia-train-details [train]="train" [original]="travelSolution"></trenitalia-train-details>
</div>